import type { SelectedReason } from './reasons';

export type TransferDestination =
  | {
      readonly kind: 'user';
      readonly id: string;
      readonly name: string;
      readonly role?: string;
      readonly queueCount?: number;
      readonly availability?: string;
    }
  | {
      readonly kind: 'queue';
      readonly id: string;
      readonly name: string;
      readonly description?: string;
      readonly caseCount?: number;
    };

export interface TransferPayload {
  readonly destination: TransferDestination;
  readonly reasons: readonly SelectedReason[];
  readonly note?: string;
  readonly caseContext?: string;
}

export type QueueListState =
  | { readonly status: 'loading' }
  | {
      readonly status: 'ready';
      readonly queues: readonly TransferDestination[];
    }
  | { readonly status: 'error'; readonly message: string };

export class TransferNotSentError extends Error {
  readonly sent = false;

  constructor(message: string) {
    super(message);
    this.name = 'TransferNotSentError';
    Object.setPrototypeOf(this, TransferNotSentError.prototype);
  }
}

export class TransferNotRecordedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TransferNotRecordedError';
    Object.setPrototypeOf(this, TransferNotRecordedError.prototype);
  }
}

export class TransferOutcomeUnknownError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TransferOutcomeUnknownError';
    Object.setPrototypeOf(this, TransferOutcomeUnknownError.prototype);
  }
}

export class TransferMoveUnconfirmedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TransferMoveUnconfirmedError';
    Object.setPrototypeOf(this, TransferMoveUnconfirmedError.prototype);
  }
}

export type TransferRecipient = Extract<TransferDestination, { kind: 'user' }>;

export type TransferPermission = 'loading' | 'allowed' | 'denied';

export interface TransferActionData {
  readonly currentUser?: { readonly displayName?: string };
  readonly initialRecipients?: readonly TransferRecipient[];
  readonly permission?: TransferPermission;
}
